import HeaderLayout from '../../../Layout/HeaderLayout';
import characters from '../../../Services/characters'
import { useDispatch } from "react-redux";
import { actions } from "../../../Store/reducer";
import { useNavigate } from "react-router-dom";
import { CONFIG_PLAYER_PATH, CUSTOMIZATION_PLAYER_PATH } from "../../../Services/routeNames";
import { PlainBox } from "../../../Components/PlainBox";
import "./characterSelectionPlayer.scss";

export default function CharacterSelectionPJ() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const ID_CUSTOM_CHARACTER = "CUSTOM_CHARACTER";

    function selectCharacter(id: string) {
        if (id === ID_CUSTOM_CHARACTER) {
            navigate(CUSTOMIZATION_PLAYER_PATH);
            return;
        }

        dispatch({
            type: actions.player.SET_CHARACTER_INFO,
            payload: {
                player: {
                    characterInfo: {
                        name: characters[id].name,
                        species: characters[id].species,
                        archetype: characters[id].archetype
                    },
                }
            },
        });

        navigate(CONFIG_PLAYER_PATH);
    }

    return (
        <div className="character-selection">
            <HeaderLayout currentPage="home" hamburger={true} isPlayer={true}>
                <span>Sélection du personnage</span>
            </HeaderLayout>

            <div className="character-list">
                {Object.entries(characters).map(([id, character], index: number) =>
                    <div className="character" key={index} onClick={() => selectCharacter(id)}>
                        <PlainBox fill={character.background} />
                        <span>{character.name}</span>
                    </div>
                )}

                <div className="character custom" onClick={() => selectCharacter(ID_CUSTOM_CHARACTER)}>
                    <PlainBox fill="#cb9e4b" />
                    <span>Créer un personnage</span>
                </div>
            </div>
        </div>
    );
}